module.exports = __webpack_public_path__ + "static/media/loader.04fcf026.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/loader.gif
// module id = 970
// module chunks = 0